import { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';
import { getDefaultTheme } from './theme';

/**
 * **Temporary** util function to use until we migrate main all clients to use `ThemeProvider`
 * If the `ThemeProvider` is not used, make sure that we default to the light theme on the library side
 * To be **used only** internally by `design-system.lib`
 */
export const fallbackTheme = (theme: BabbelTheme | undefined) => {
  if (!theme || Object.keys(theme).length === 0) {
    return getDefaultTheme();
  }
  return theme;
};
